<template>
  <div class="expander" :class="{ 'expanded': isExpanded }">
    <button type="button" class="expander-btn" @click="isExpanded = !isExpanded">
      <div class="header">
        <slot name="header"></slot>
      </div>
      <span class="decoration"></span>
    </button>
    <div class="content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'expander',
    data () {
      return {
        isExpanded: false
      }
    }
  }
</script>

<style lang="scss" scoped>

  @import "~globals";

  $button-height: 0.8rem;
  $button-width: 0.7rem;

  .expander {
    .expander-btn {
      position: relative;
      width: 100%;
      text-align: left;

      .header {
        margin-right: 2rem;
      }

      .decoration {
        @include position(absolute, 50% 0 null null);
        width: 0;
        height: 0;
        border-style: solid;
        border-width: $button-height $button-width 0 $button-width;
        border-color: $color-gray-darkest transparent transparent transparent;
      }

      &:hover .decoration {
        border-top-color: $color-primary;
      }
    }

    .content {
      display: none;
    }

    &.expanded {
      .expander-btn {
        border-bottom: 1px solid $color-gray-darkest;

        .decoration {
          border-width: 0 $button-width $button-height $button-width;
          border-color: transparent transparent $color-gray-darkest transparent;
        }

        &:hover .decoration {
          border-bottom-color: $color-primary;
        }
      }
      .content {
        display: block;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/_global/expander.vue